import { useEffect, useState, FC } from 'react';
import Chip from '@mui/material/Chip';
import { useGetCustomersPaginatedQuery } from 'src/reactQuery/customers/queries/useGetCustomersPaginated';
import { SelectUsersElementProps, UsersSelectData } from './interfaces/usersSelect.interface';
import { AutocompleteSelect } from '../Select';
import Loader from '../Loader/Loader';

const SelectUsersElement: FC<SelectUsersElementProps> = ({ value, onChange = () => {} }) => {
  const [contents, setContents] = useState<UsersSelectData[]>([]);
  const [remainingUsersToSelect, setRemainingUsersToSelect] = useState<UsersSelectData[]>([]);
  const { data: customerData, isLoading } = useGetCustomersPaginatedQuery({ pageSize: '400' });

  function selectContent(selectedUserInfo: UsersSelectData) {
    const selectedContent = contents.filter((content) => content.id === selectedUserInfo.id);
    onChange([...value, selectedContent[0]]);
  }

  function removeSelectedContent(userId: string) {
    const filteredContents = value.filter((content: UsersSelectData) => content.id !== userId);
    onChange([...filteredContents]);
  }

  useEffect(() => {
    if (!customerData) return;

    const { users } = customerData;

    if (!users || !users.length) return;

    users.forEach((user) => {
      const { firstName, lastName, _id: id } = user;
      setContents((oldData) => [...oldData, { firstName, id, lastName }]);
    });
  }, [customerData]);

  useEffect(() => {
    const remainingUsers = contents.filter((content) => {
      const isContentAlreadySelected = value?.some(
        (chosenContent: UsersSelectData) => chosenContent.id === content.id
      );
      const isDisplayed = !isContentAlreadySelected;
      return isDisplayed;
    });
    setRemainingUsersToSelect([...remainingUsers]);
  }, [value, contents]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          margin: 'auto',
          textAlign: 'start'
        }}
      >
        {value?.map((user: UsersSelectData) => {
          return (
            <Chip
              key={user.id}
              label={`${user?.firstName} ${user?.lastName}`}
              onClick={() => {
                navigator.clipboard.writeText(`${user?.firstName} ${user?.lastName}`);
              }}
              onDelete={() => removeSelectedContent(user.id)}
            />
          );
        })}
      </div>

      <AutocompleteSelect
        getOptionLabel={(option: UsersSelectData) => `${option?.firstName} ${option?.lastName}`}
        id="autocomplete-contentDetailBody-selectContents"
        onSelect={selectContent}
        onViewAll={() => {}}
        options={remainingUsersToSelect}
        placeholderValue="Select Users"
      />
    </div>
  );
};

export default SelectUsersElement;
